<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container grid-list-xl fluid v-else>
            <v-row wrap>
                <v-col lg="12">
                    <data-table
                        ref="tableConfig"
                        :tableName="'Configuración'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :showAdvancedFilters="true"
                        :perPage="[10, 25, 50, 100]"
                    >   
                        <template slot="filters">
                            <v-col xs="12" sm="12" md="12" class="py-0">
                                <v-text-field
                                    outlined
                                    label="Nombre"
                                    v-model="advancedSearch.nombre"
                                ></v-text-field>
                            </v-col>
                            <v-col v-if="rol == 'root'" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="clientes"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Cliente"
                                    persistent-hint
                                    v-model="cliente_value_search"
                                ></v-autocomplete>
                            </v-col>
                            <v-col v-if="rol == 'root' || rol == 'admin'" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="empresas"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Empresa"
                                    persistent-hint
                                    v-model="empresa_value_search"
                                ></v-autocomplete>
                            </v-col>
                        </template>
                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div>
                                        {{ item.nombre_cliente }}
                                    </div>
                                    <div>
                                        {{ item.nombre_empresa }}
                                    </div>
                                </td>
                                <td>
                                    <div>{{ item.nombre }}</div>
                                </td>
                                <td>
                                    <div>{{ item.descripcion }}</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <!--Modal-->
        <template>
            <v-row justify-center>
                <v-dialog v-model="dialog" persistent max-width="700px" scrollable>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>

                    <perfect-scrollbar style="background:#FFF">
                        <v-card elevation="0">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imgModal" class="imgModal" />
                                    <h2 class="titleModal">{{ titulo_modal }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <div id="loadingModal" v-show="!finaliza_carga">
                                    <div id="loading">
                                    <v-progress-circular
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"
                                    ></v-progress-circular>
                                    </div>
                                </div>

                                <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row wrap>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-text-field
                                                outlined
                                                class="estiloLetras"
                                                label="Nombre"
                                                v-model="configuracion.nombre"
                                                disabled
                                                v-validate="'required'"
                                                data-vv-name="Nombre"
                                                :error-messages="errors.collect('Nombre')"
                                            >
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-text-field
                                                outlined
                                                class="estiloLetras"
                                                label="Descripción"
                                                v-model="configuracion.descripcion"
                                                v-validate="'required'"
                                                data-vv-name="Descripción"
                                                :error-messages="errors.collect('Descripción')"
                                            >
                                            </v-text-field>
                                        </v-col>

                                        <template
                                            v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'"
                                        >
                                            <template v-if="rol == 'root'">
                                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                    <v-autocomplete
                                                        outlined
                                                        :items="clientes"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        class="estiloLetras"
                                                        label="Cliente"
                                                        persistent-hint
                                                        disabled
                                                        v-model="cliente_value"
                                                    >
                                                    </v-autocomplete>
                                                </v-col>
                                            </template>

                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" v-if="rol != 'admin-empresa'" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="empresas"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    class="estiloLetras"
                                                    label="Empresa"
                                                    persistent-hint
                                                    disabled
                                                    v-model="empresa_value"
                                                    v-validate="'required'"
                                                    data-vv-name="Empresa"
                                                    :error-messages="errors.collect('Empresa')"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </template>

                                        <!-- Configuracion de texto de correo incidencias -->
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <v-textarea
                                                outlined
                                                v-if="clave == 'correo_incidencia'"
                                                class="estiloLetras"
                                                v-model="configuracion.valor"
                                                label="Mensaje Email"
                                                outline
                                                v-validate="'required'"
                                                data-vv-name="Email"
                                                rows="2"
                                                :error-messages="errors.collect('Email')"
                                            ></v-textarea>

                                            <!-- Configuracion por faltas -->
                                            <v-text-field
                                                outlined
                                                v-else-if="clave == 'notificacion_faltas'"
                                                v-model="configuracion.valor"
                                                class="estiloLetras py-0 my-0"
                                                label="Notificación por numero de faltas"
                                                type="number"
                                                data-vv-name="Num de faltas"
                                                v-validate="'required|numeros_positivos'"
                                                :error-messages="errors.collect('Num de faltas')"
                                            ></v-text-field>

                                            <!-- Configuracion de vacaciones -->
                                            <v-container
                                                v-else-if="clave == 'vacaciones_acomulables'"
                                                class="sexo"
                                                fluid
                                                grid-list-xl
                                            >
                                                <v-row justify-center>
                                                    <v-col cols="12" xs="12" sm="5" md="5" lg="5" xl="5" class="pt-0 pb-0 ma-0">
                                                        <template>
                                                            <v-container class="ma-0 pa-0" fluid>
                                                                <h4 class="tituloRadio">
                                                                    Vacaciones Acumulables
                                                                </h4>
                                                                <v-radio-group
                                                                    class="ma-0 pa-0"
                                                                    v-model="configuracion.valor"
                                                                    row
                                                                >
                                                                    <v-radio label="Si" value="S"></v-radio>
                                                                    <v-radio label="No" value="N"></v-radio>
                                                                </v-radio-group>
                                                            </v-container>
                                                        </template>
                                                    </v-col>
                                                </v-row>
                                            </v-container>

                                            <!-- Configuracion de ranking -->
                                            <v-container
                                                v-else-if="clave == 'empleado_ranking'"
                                                class="sexo"
                                                fluid
                                                grid-list-xl
                                            >
                                            <v-row justify-center>
                                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0 ma-0">
                                                    <h4 class="tituloRadio">
                                                        Configuracion del ranking
                                                    </h4>

                                                    <template v-for="(value, index) in ranking">
                                                        <v-text-field
                                                            :key="index"
                                                            v-model="value.value"
                                                            outlined
                                                            class="estiloLetras py-0 my-0"
                                                            :label="value.name"
                                                            type="number"
                                                            v-validate="'required|numeros_positivos'"
                                                            :data-vv-name="value.name"
                                                            :error-messages="errors.collect(value.name)"
                                                        ></v-text-field>
                                                    </template>
                                                </v-col>
                                            </v-row>
                                            </v-container>
                                            <!--Configuración notificación contratos-->
                                            <v-container
                                                v-else-if="clave == 'notificaciones'"
                                                class="sexo pa-0"
                                                fluid
                                                grid-list-xl
                                            > 
                                                <div v-for="item in arrNotificaciones" :key="item.clave">
                                                    <h4 class="tituloRadio mb-2">
                                                        {{ item.nombre }}
                                                    </h4>
                                                    <v-row class="ma-0 px-0">
                                                        <!--USUARIOS FALTAS-->
                                                        <v-col 
                                                            cols="5" 
                                                            sm="5" 
                                                            md="5" 
                                                            class="py-0 pl-0"
                                                            v-if="item.clave == 'faltas'"
                                                            >
                                                            <multiple-autocomplete
                                                            outlined
                                                            :items="usuarios"
                                                            item_text="nombre"
                                                            @dataMultiple="(data)=> usuariosFaltas = data"
                                                            :valorDefecto="usuariosFaltas"
                                                            label="Usuarios"
                                                            ref="multUsuariosFaltas"
                                                            />
                                                        </v-col>
                                                        <!--USUARIOS CONTRATOS-->
                                                        <v-col 
                                                            cols="5" 
                                                            sm="5" 
                                                            md="5" 
                                                            class="py-0 pl-0"
                                                            v-if="item.clave == 'contratos'"
                                                            >
                                                            <multiple-autocomplete
                                                            outlined
                                                            :items="usuarios"
                                                            item_text="nombre"
                                                            @dataMultiple="(data)=> usuariosContratos = data"
                                                            :valorDefecto="usuariosContratos"
                                                            label="Usuarios"
                                                            ref="multUsuariosContratos"
                                                            />
                                                        </v-col>
                                                        <!--USUARIOS TARJETAS SALUD-->
                                                        <v-col 
                                                            cols="5" 
                                                            sm="5" 
                                                            md="5" 
                                                            class="py-0 pl-0"
                                                            v-if="item.clave == 'tarjetas'"
                                                            >
                                                            <multiple-autocomplete
                                                            outlined
                                                            :items="usuarios"
                                                            item_text="nombre"
                                                            @dataMultiple="(data)=> usuariosTarjetas = data"
                                                            :valorDefecto="usuariosTarjetas"
                                                            label="Usuarios"
                                                            ref="multUsuariosTarjetas"
                                                            />
                                                        </v-col>
                                                        <v-col 
                                                            cols="5" 
                                                            sm="5" 
                                                            md="5" 
                                                            class="py-0 d-flex pr-0"
                                                            :class="item.clave == 'cumpleanios' ? 'pl-0': ''"
                                                            v-if="item.clave == 'faltas' || item.clave == 'contratos' || item.clave == 'tarjetas' || item.clave == 'cumpleanios'"
                                                            >
                                                            <v-text-field
                                                                outlined
                                                                v-model="item.dias"
                                                                class="estiloLetras py-0 my-0"
                                                                type="number"
                                                                label="Días"
                                                                v-validate="'required|numeros_positivos'"
                                                                data-vv-name="Dias"
                                                                :error-messages="errors.collect('Dias')"
                                                            ></v-text-field>
                                                            <v-tooltip top class="pb-7" v-if="item.clave == 'contratos'">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon
                                                                    color="#96999A"
                                                                    v-on="on"
                                                                    slot="activator"
                                                                    class="pb-7 pl-2 outlined_v_icon"
                                                                    >info</v-icon
                                                                    >
                                                                </template>
                                                                <span class="pb-7 textTooltip">
                                                                    Días de anticipación para la notificación<br>
                                                                    del vencimiento de contrato.
                                                                </span>
                                                            </v-tooltip>
                                                        </v-col>
                                                        <v-col 
                                                            cols="2" 
                                                            class="py-0"
                                                            v-if="item.clave == 'faltas' || item.clave == 'contratos' || item.clave == 'tarjetas' || item.clave == 'cumpleanios'"
                                                            >
                                                            <v-checkbox
                                                                label="Activo"
                                                                class="mb-0 mx-0 mt-3"
                                                                v-model="item.activo"
                                                            ></v-checkbox>   
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()"
                                    :disabled="loading_guardar"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="guardar()"
                                    :loading="loading_guardar"
                                >
                                    Guardar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </v-row>
        </template>
    </div>
</template>

<script>
import documentoApi from "../api/tipo_documentos";
import configuracionesApi from "../api/configuraciones";
import clienteApi from "../api/clientes";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import Swal from "sweetalert2";
import Datatable from "@/components/datatable/Datatable.vue";
import Notify from "@/plugins/notify";
import PerfectScrollbar from "perfect-scrollbar";
import usuariosApi from '@/api/usuarios.js'
import VuetifyMultipleAutocomplete2 from './../components/VuetifyMultipleAutocomplete2.vue'

export default {
    components: {
        "data-table": Datatable,
        "multiple-autocomplete": VuetifyMultipleAutocomplete2
    },
    data() {
        return {
            url: "configuraciones/find",
            columns: [
                {
                    label: "Cliente",
                    name: "cliente",
                    filterable: true,
                },
                {
                    label: "Nombre",
                    name: "nombre",
                    filterable: true,
                },
                {
                    label: "Descripción",
                    name: "descripcion",
                    filterable: true,
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                    align: 'center'
                },
            ],
            filters         : {
                activo      : true,
                paginate    : true,
                include_padres: true,
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                order_by    : 'nombre',
                sistema     : 'gdth',
                nombre      : null
            },
            advancedSearch  : {
                nombre      : null,
                correo      : "",
                direccion   : "",
                telefono    : "",
            },

            loading_guardar     : false,
            loading             : true,
            dialog              : false,
            search              : "",
            datosLogin          : "",
            menu                : false,
            ranking             : [],
            configuracion       : {
                id              : 0,
                nombre          : null,
                descripcion     : null,
                empresa_id      : null,
                sucursal_id     : null,
                valor           : null,
            },
            titulo_modal        : "",
            finaliza_carga      : false,
            accion              : "",

            sucursales          : [],
            empresas            : [],
            clientes            : [],
            usuarios            : [],

            clientes_search     : [],
            empresa_search      : [],
            sucursal_search     : [],

            cliente_value_search: null,
            empresa_value_search: null,
            sucursal_value_search: null,

            conteo_parametros   : 0,
            cliente_value       : null,
            empresa_value       : null,
            sucursal_value      : null,
            rol                 : null,
            clave               : null,
            busqueda            : false,
            imgModal            : "/static/modal/configuracionGeneral.svg",
            arrNotificaciones     : [],
            usuariosFaltas: [],
            usuariosContratos: [],
            usuariosTarjetas: []
        };
    },
    watch: {
        cliente_value: function(val) {
            if(val != null){
                this.cambiaCliente(val);
            }
        },
        cliente_value_search: function(val) {
            if(val != null){
                this.cambiaCliente(val);
            }
        },
        empresa_value: function(val) {
            if(val != null){
                this.cambiaEmpresa(val);
            }
        },
        empresa_value_search: function(val) {
            if(val != null){
                this.cambiaEmpresa(val);
            }
        },
        clave: function(val) {
            console.log(val);
        }
    },
    methods: {
        async listar() {
            let cliente_id = null;
            let empresa_id = null;

            await this.resetValue();

            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;
            if (this.rol == "root") {
                this.getClientes();
            }
            if (this.rol == "admin") {
                this.cliente_value_search = this.filters.cliente_id = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                this.empresa_value_search = this.filters.empresa_id = this.datosLogin.empresa_id;
            }
        },
        async loadModalData(){
            await this.resetValue()
            if(this.rol == 'root'){
                this.getClientes()
            }
            else if(this.rol == 'admin'){
                this.cliente_value = this.datosLogin.cliente_id;
            }
            else if(this.rol == 'admin-empresa'){
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }

        },
        setFilters() {
            let cliente = this.cliente_value_search;
            let empresa = this.empresa_value_search;
            let sucursal = this.sucursal_value_search;
            let nombre = this.advancedSearch.nombre

            if (this.rol == "admin") {
                cliente = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                empresa = this.datosLogin.empresa_id;
            }

            this.filters.cliente_id = cliente
            this.filters.empresa_id = empresa
            this.filters.nombre = nombre

            /* let filterParams = {
                cliente_id: cliente,
                empresa_id: empresa,
                sucursal_id: sucursal,
                nombre: nombre,
                sistema: 'gdth'
            };

            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;
 */
            this.$refs.tableConfig.getData()

            this.empresa_value_search = null;

            if (this.rol == "root") {
                this.cliente_value_search = null;
            }
            this.sucursal_value_search = null;
        },
        eliminar(id, nombre) {
            let self = this;
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar la configuración " + nombre + "?",
                "Eliminar",
                () => {
                this.loading = true;
                configuracionesApi
                    .deleteConfiguracion(id)
                    .then((response) => {
                    self.$refs.tableConfig.getData();
                    self.listar();
                    Notify.Success(
                        "Configuación eliminada",
                        "La configuración ha sido eliminada satisfactoriamente"
                    );
                    })
                    .catch((err) => {
                    console.log(err);
                    Notify.ErrorToast(err.response.data.error);
                    });
                }
            );
        },
        cerrarModal() {
            this.dialog = false;
            this.conteo_parametros = 0;
            this.loading_guardar = false;
            this.resetValue();
        },
        async resetValue() {
            this.ranking = [];
            this.configuracion = {
                id: 0,
                nombre: null,
                descripcion: null,
                empresa_id: null,
                sucursal_id: null,
                valor: null,
            };
            this.conteo_parametros = 0;
            this.cliente_value = null;
            this.empresa_value = null;
            this.sucursal_value = null;

            this.cliente_value_search = null;
            this.sucursal_value_search = null;
            this.empresa_value_search = null;

            this.usuarios = []
            this.usuariosFaltas = []
            this.usuariosContratos = []
            this.usuariosTarjetas = []
        },
        async abrirModal(accion, item = null) {
            await this.resetValue();
            this.errors.clear();
            this.accion = accion;

            if (accion == "add") {
                this.titulo_modal = "Configuración general.";
            } else if (accion == "update") {
                this.titulo_modal = "Configurar información general.";
                this.configuracion.id = item.id;
                this.configuracion.nombre = item.nombre;
                this.configuracion.descripcion = item.descripcion;
                this.configuracion.valor = item.valor;
                this.cliente_value = item.cliente_id;
                this.configuracion.cliente_id = item.cliente_id;
                this.empresa_value = item.empresa_id;
                this.configuracion.empresa_id = item.empresa_id;
                this.sucursal_value = item.sucursal_id;
                this.configuracion.sucursal_id = item.sucursal_id;
                this.clave = item.clave;

                if (item.clave == "empleado_ranking") {
                this.ranking = JSON.parse(item.valor);
                }

                if(item.clave == "notificaciones"){
                    this.getUsuarios()
                    this.arrNotificaciones = JSON.parse(item.valor)
                    this.usuariosFaltas = this.arrNotificaciones[0].usuarios_id //faltas
                    this.usuariosContratos = this.arrNotificaciones[1].usuarios_id //contratos
                    this.usuariosTarjetas = this.arrNotificaciones[2].usuarios_id //tarjetas salud
                }
            }

            if (this.rol == "root") {
                this.finaliza_parametros();
                this.getClientes();
            }

            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.getEmpresas(this.datosLogin.cliente_id);
            }

            if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }
            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
        },
        getClientes(cliente = null) {
            let self = this;
            let param = { activo: true, paginate: false };
            clienteApi
                .getClientes(param)
                .then((response) => {
                this.clientes_search = this.clientes = response.data;
                this.finaliza_parametros();
                setTimeout(function() {
                    self.finaliza_parametros();
                }, 300);
                })
                .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
                });
        },
        getEmpresas(id) {
            let parametros = {
                activo: true,
                paginate: false,
                cliente_id: id,
            };
            empresaApi.getEmpresas(parametros).then((response) => {
                this.empresas = response.data;
                this.finaliza_parametros();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        cambiaCliente(cliente, empresa = null) {
            let param = {
                activo: true,
                paginate: false,
                cliente_id: cliente,
            };
            empresaApi.getEmpresas(param).then((response) => {
                this.empresas = response.data;

                if (cliente != null) {
                    this.empresa_search = this.empresas;
                    this.cliente_value_search = cliente;
                }
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        cambiaEmpresa(id, sucursal = null) {
            let parametros = {
                activo: true,
                paginate: false,
                empresa_id: id,
            };
            sucursalApi.getSucursales(parametros).then((response) => {
                this.sucursales = response.data;
                if (id != null) {
                    this.sucursal_search = this.sucursales;
                }
                this.finaliza_parametros();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        getUsuarios(){
            let parametros = {
                activo: true,
                paginate: false,
                cliente_id: this.cliente_value,
                administradores: true
            }

            usuariosApi.getUsuarios(parametros).then(resp => {
                this.usuarios = resp.data
                //console.log(this.usuarios);
            }).catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los usuarios.");
            })
        },
        guardar() {
            this.$validator.validate().then((result) => {
                if (result) {
                    this.loading_guardar = true;
                    this.configuracion.cliente_id = this.cliente_value;
                    this.configuracion.empresa_id = this.empresa_value;
                    this.configuracion.sucursal_id = this.sucursal_value;

                    if (this.clave == "empleado_ranking") {
                        let valor = JSON.stringify(this.ranking);
                        this.configuracion.valor = valor;
                    }

                    if(this.clave == "notificaciones"){
                        this.arrNotificaciones[0].usuarios_id = this.usuariosFaltas
                        this.arrNotificaciones[1].usuarios_id = this.usuariosContratos
                        this.arrNotificaciones[2].usuarios_id = this.usuariosTarjetas
                        let valor = JSON.stringify(this.arrNotificaciones)
                        this.configuracion.valor = valor
                    }

                    if (this.accion === "add") {
                        configuracionesApi
                        .addConfiguracion(this.configuracion)
                        .then((response) => {
                            this.$refs.tableConfig.getData();
                            this.respuesta_ok(
                            "Se creó la configuración satisfactoriamente."
                            );
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    } else if (this.accion === "update") {
                        configuracionesApi
                        .updateConfiguracion(this.configuracion)
                        .then((response) => {
                            this.$refs.tableConfig.getData();
                            this.respuesta_ok(
                            "Se actualizo la configuración satisfactoriamente."
                            );
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    }
                }
            });
        },
        finaliza_parametros() {
            this.finaliza_carga = true;
        },
        respuesta_error(err) {
            this.cerrarModal();
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj) {
            this.listar();
            this.cerrarModal();
            Notify.Success("Operación exitosa", msj);
        },
        busquedaAvanzada() {
            switch (this.rol) {
                case "root":
                this.busqueda = true;
                break;
                case "admin":
                this.busqueda = true;
                break;
                case "admin-empresa":
                this.busqueda = true;
                break;
                case "admin-sucursal":
                this.busqueda = false;
                break;
                default:
                return false;
                break;
            }
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
    }, //Fin Methods
    created() {
        this.loading = true;
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;

        if (this.rol == "root") {
            this.getClientes();
        }
        if (this.rol == "admin") {
            this.cliente_value_search = this.filters.cliente_id = this.datosLogin.cliente_id;
        } else if (this.rol == "admin-empresa") {
            this.filters.empresa_id = this.datosLogin.empresa_id;
        }
        this.busquedaAvanzada();
    },
    mounted() {
        this.listar();
    },
};
</script>

<style scoped>
    .tituloRadio {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0.2px;
        color: #a0a4a8;
        padding-bottom: 10px;
        margin-bottom: 20px;
    }
</style>
